import i18n from 'i18n';
import yup from 'utils/yup';

export const getValidationSchema = (isLanding) => {
  const formFields = {
    firstName: yup.string().required(i18n.t('common.validation.required')).nullable(),
    lastName: yup.string().required(i18n.t('common.validation.required')).nullable(),
    email: yup.string().email(i18n.t('common.validation.email.invalid')).nullable(),
  };

  if (isLanding) {
    formFields.sharePersonalInformation = yup.bool().checked();
  }

  return yup.object().shape({ ...formFields });
};
